import type { GridApi } from 'ag-grid-community';
import { t } from '../i18n/t';

// Toolbar export button: the grid's current (filtered/sorted) rows as CSV.
export function exportGridCsv(api: GridApi<any> | null, resourceCode: string): void {
  if (!api) return;
  const today = new Date().toISOString().slice(0, 10);
  api.exportDataAsCsv({
    fileName: `${resourceCode}-${today}.csv`,
    allColumns: false,
    processCellCallback: (params) => {
      if (typeof params.value === 'boolean') {
        return params.value ? t('common.yes') : t('common.no');
      }
      return params.value;
    },
  });
}
